import { SystemMessage } from 'components/Dialogue';
import { get } from 'lodash-es';
import { BaseSysMsgProps } from './types';
import { memo } from 'react';
import { useTranslate } from '@tolgee/react';

export const SysFaqQuestionMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const text = get(raw, 'sysFaqQuestionContent')?.question;
  const { t } = useTranslate();

  return (
    <SystemMessage>
      {t('messageType.SYS_FAQ_QUESTION', {
        text,
      })}
    </SystemMessage>
  );
});
